// extracted by mini-css-extract-plugin
export default {"dashboard_container":"UserDashboardLayout_dashboard_container__llKhT"};